import {SousMenuItemAggregate} from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import {AutorisationsAggregate} from '../../../../../aggregats/autorisation/autorisations.aggregate';
import {AutorisationAggregate} from '../../../../../aggregats/autorisation/autorisation.aggregate';
import {FonctionLogicielle} from '../../../../fonctions-logicielle-constantes';
import {EparcoursPath} from '../../eparcours-path';

export const modelesSousMenuItem = new SousMenuItemAggregate(
  'Modèles documents',
  `/${EparcoursPath.root.PUBLIPOSTAGE_MODELES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.ConceptionModeles)]),
);

export const evaluationsModelesSousMenuItem = new SousMenuItemAggregate(
  'Modèles évaluations',
  `/${EparcoursPath.root.EVALUATIONS}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Evaluations)], null, true),
);
